import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import { Boxes, Minus, Plus, AlertTriangle } from "lucide-react";

export default function Stock() {
  const [prods, setProds] = useState([]);
  const load = () => api.get("/products").then((r) => setProds(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const patch = async (id, body) => {
    try { await api.patch(`/products/${id}/stock`, body); load(); } catch (e) { toast.error(errMsg(e)); }
  };

  const tracked = prods.filter((p) => p.trackStock);
  const low = tracked.filter((p) => p.stock <= 5);

  return (
    <div>
      <h1 className="font-serif text-3xl sm:text-4xl text-white mb-1">Stok Takibi</h1>
      <p className="text-zinc-400 text-sm mb-6">Stok takibi açık ürünleri yönetin, kritik seviyeleri görün</p>

      {low.length > 0 && (
        <div className="card-lux p-4 mb-6 border border-amber-500/30 bg-amber-950/20 flex items-center gap-3" data-testid="low-stock-alert">
          <AlertTriangle className="text-amber-400" size={20} />
          <span className="text-amber-200 text-sm">{low.length} üründe kritik stok seviyesi ({low.map((p) => p.name).join(", ")})</span>
        </div>
      )}

      <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {prods.map((p) => (
          <div key={p.id} className="card-lux p-4" data-testid={`stock-${p.id}`}>
            <div className="flex items-center justify-between">
              <h3 className="font-serif text-lg text-white">{p.name}</h3>
              <Boxes size={18} className="text-[#D4AF37]/50" />
            </div>
            <div className="flex flex-wrap gap-4 mt-3 text-sm">
              <label className="flex items-center gap-2 text-zinc-300 cursor-pointer">
                <input type="checkbox" checked={p.trackStock} onChange={(e) => patch(p.id, { trackStock: e.target.checked })} className="accent-[#D4AF37] w-4 h-4" data-testid={`track-${p.id}`} /> Stok Takibi
              </label>
              <label className="flex items-center gap-2 text-zinc-300 cursor-pointer">
                <input type="checkbox" checked={p.isAvailable} onChange={(e) => patch(p.id, { isAvailable: e.target.checked })} className="accent-[#D4AF37] w-4 h-4" data-testid={`avail-${p.id}`} /> Satışta
              </label>
            </div>
            {p.trackStock && (
              <div className="flex items-center justify-between mt-4 pt-3 border-t border-[#D4AF37]/15">
                <span className={`font-mono text-sm ${p.stock <= 5 ? "text-amber-400" : "text-[#FFE599]"}`}>Kalan: {p.stock} adet</span>
                <div className="flex items-center gap-2">
                  <button onClick={() => patch(p.id, { stock: Math.max(0, p.stock - 1) })} className="btn-outline h-8 w-8 rounded-lg flex items-center justify-center" data-testid={`stock-dec-${p.id}`}><Minus size={15} /></button>
                  <button onClick={() => patch(p.id, { stock: p.stock + 1 })} className="btn-gold h-8 w-8 rounded-lg flex items-center justify-center" data-testid={`stock-inc-${p.id}`}><Plus size={15} /></button>
                  <button onClick={() => patch(p.id, { stock: p.stock + 10 })} className="btn-outline px-3 h-8 rounded-lg text-xs" data-testid={`stock-add10-${p.id}`}>+10</button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
